import { render, staticRenderFns } from "./ModerationTemplate.vue?vue&type=template&id=5f2f69f0&"
import script from "./ModerationTemplate.vue?vue&type=script&lang=ts&"
export * from "./ModerationTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports